export const R = {
	"InsuranceProviderFreeAccess": "Kunder hos {0} har fri adgang til:",
	"AdditionalServicesSelfPayment": "Øvrige services er tilgængelige mod &lt;b&gt;egen betaling&lt;/b&gt;.",
	"AdditionalServicesNotAvailable": "Der er &lt;b&gt;ikke adgang&lt;/b&gt; til øvrige services.",
	"ReferralsHeading": "Henvisninger",
	"ReferralsCanBeReferredTo": "Kunder hos {0} kan henvises til:",
	"ReferralsSentViaXMedicus": "Henvisninger sendes direkte i XMedicus",
	"ReferralsPatientSendsCopy": "Patienten sender selv kopi af journalnotat til selskab",
	"AdditionalInfoHeading": "Andet"
}